import IncomeTab from "./IncomeTab";

export default IncomeTab;
